module.exports = __webpack_public_path__ + "img/安宁市第一人民医院.3d3524bc.png";